import React from "react";
import { withTranslation } from "react-i18next";
import "rc-time-picker/assets/index.css";
import { Modal, ModalBody, Spinner } from "reactstrap";
import crossIcon from "assets/images/cross.svg";
import Text from "components/Text";
import styles from "../OfficePolicyManagement.module.scss";
import { usePolicyHistoryById } from "../../../../repositories/office-policy-management-repository";
import { addDefaultStaffRounded } from "../../../../utils";
import { actionValues } from "./PolicyDetailsHistoryLogs";
function AssignedAndRenotifyModal({
  t,
  issaveEmployeeModalOpen,
  setIsSaveEmployeeModalOpen,
  data,
}) {
  const {data: historyData,isLoading: isHistoryLoading,isFetching: isHistoryFetching}=usePolicyHistoryById(data?.id, {
    enabled: !!data?.id,
  })
  const isLoading=isHistoryLoading||isHistoryFetching;
  const notifiedUsers=historyData?.data?.assignees||[]
  return (
    <Modal
      isOpen={issaveEmployeeModalOpen}
      toggle={() => setIsSaveEmployeeModalOpen(false)}
      className="modal-dialog-centered modal-lg"
      modalClassName="custom-modal"
    >
      <span
        className="close-btn"
        onClick={() => setIsSaveEmployeeModalOpen(false)}
      >
        <img src={crossIcon} alt="close" />
      </span>
      <ModalBody className={styles["add-employee-modal-dialog"]}>
        <Text size="25px" marginBottom="10px" weight="500" color="#111b45">
          <span className="modal-title-25">
          {data?.action === actionValues.ReNotified ? "Re-notified" : "Assigned"} To
          </span>
        </Text>
{/* User List */}
{isLoading&& <div style={{ padding: "1rem", textAlign: "center" }}>
          <Spinner animation="border" size="sm" className="loader-spinner" />
        </div>}
<ul className={` ${styles["userList"]} ${["re-notified-list"]} `}>
        {notifiedUsers.map((user) => (
          <li key={user.id} className={styles.userListItem}>
            
            {/* Avatar / Placeholder */}
            <div className={styles.avatarWrapper}>
              {user.avatar ? (
                <img src={user.profilePic} alt={`Avatar for ${user.name}`} onError={addDefaultStaffRounded} className={styles.avatarImage} />
              ) : (
                <div className={styles.avatarPlaceholder} aria-label="Default avatar">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z" />
                  </svg>
                </div>
              )}
            </div>

            {/* User Details */}
            <div className={styles.userInfo}>
              <span className={styles.userName}>{user.name}</span>
              <span className={styles.userRole}>{user.role}</span>
            </div>
          </li>
        ))}
      </ul>

      <button
          className="button button-round button-shadow mr-sm-3 mb-3 w-sm-100 mt-3"
          title={t("accountOwner.addEmployees")}
          onClick={() => {
            setIsSaveEmployeeModalOpen(false);
          }}
        >
          Close
        </button>
        </ModalBody>
    </Modal>
  );
}

export default withTranslation()(AssignedAndRenotifyModal);
